// extracted by mini-css-extract-plugin
module.exports = {"InputElement":"TextToSpeech_InputElement__1zdBi","Note":"TextToSpeech_Note__qiy6R","Grouping":"TextToSpeech_Grouping__Cdrw9","texting":"TextToSpeech_texting__3kM-0"};